import { createContext } from 'react';
import { HighlySensitivePropertyContextValue } from './HighlySensitivePropertyContextTypes';

export const HighlySensitivePropertyContext = createContext<
  HighlySensitivePropertyContextValue | undefined
>(undefined);
